import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import GetProviderQuery from 'GraphQueries/Providers/GetQuery';
import UpdateProviderMutation from 'GraphQueries/Providers/UpdateMutation';

import PageNavigationTabs from 'Components/Presentation/_Shared/Layout/PageNavigationTabs';
import ProviderEdit from 'Components/Presentation/Providers/ProviderEdit';
import ExternalFieldList from 'Components/Presentation/Providers/ExternalFields/ExternalFieldList';

class ProviderEditContainer extends React.Component {

    static defaultProps = { 
        provider: { name: '', externalFields: [] },
        loading: false,
        pageTabs: [
            { label: 'Back To List', path: 'list', includeId: false },
            { label: 'Settings', path: 'manage/settings', includeId: true },
            { label: 'External Field', path: 'manage/external-fields', includeId: true }
        ]
    }

    state = { 
        activeTabIndex: 1,
        saving: false
    }

    tabClickHandler = (el, key) => {
        const { history, match: { params } } = this.props;
        history.push(el.includeId ?
            `/data-tools/providers/${params.id}/${el.path}` :
            `/data-tools/providers/${el.path}`);
        this.setState({ activeTabIndex: key });
    }

    setActiveTab = index => {
        this.setState({ activeTabIndex: index });
    }

    navigateWithData = (uri) => {
        const { history } = this.props;
        history.push(uri);
    }

    saveProvider = async (provider, action = '') => {
        const { onAlert, onUpdate } = this.props;
        this.setState({ saving: true });

        delete provider.__typename;

        onUpdate(provider).then(x => { 
            let message = '';
            switch (action) {
                case 'add_external_field':   
                    message = `Successfully added external field to provider: ${provider.id}`;
                    break;
                case 'update_external_field':
                    message = `Successfully updated external field on provider: ${provider.id}`;
                    break;
                case 'delete_external_field':
                    message = `Successfully deleted external field on provider: ${provider.id}`;
                    break;
                default:
                    message = `Successfully updated provider: ${provider.id}`
                    break;                    
            }            
            this.setState({ saving: false });
            onAlert('success', `${message}`);        
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to update providers, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    render() {
        const { provider, loading, pageTabs } = this.props;
        const { activeTabIndex, saving } = this.state;
        return (
            <React.Fragment>
                <PageNavigationTabs pageTabs={pageTabs} activeTabIndex={activeTabIndex} onTabClick={this.tabClickHandler} />
                <Route path="/data-tools/providers/:id/manage/settings" render={props =>
                    <ProviderEdit provider={provider} loading={loading || saving} onProviderUpdated={this.saveProvider} onActivate={event => this.setActiveTab(1)} />} />
                <Route path="/data-tools/providers/:id/manage/external-fields" render={props =>
                    <ExternalFieldList provider={provider} loading={loading || saving} onProviderUpdated={this.saveProvider} onActivate={event => this.setActiveTab(2)} />} />
            </React.Fragment>
        );
    }
}

export default
    compose(
        graphql(GetProviderQuery, {
            options: ({ match: { params: { id } } }) => ({ variables: { id } }),
            props: ({ data: { getProvider, loading } }) => ({ provider: getProvider, loading })
        }),
        graphql(UpdateProviderMutation(['externalFields']), { 
            props: ({ mutate }) => ({ onUpdate: input => mutate({ variables: { input } }) }) 
        })
    )(ProviderEditContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Providers/Edit.js